export default {
  ADD_REPORT_BUY_INQUIRY: "setReportBuyInquiry",
  ADD_REPORT_BUY_INQUIRY_ERROR: "setReportBuyInquiryError",
  ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY: "setReportBuyLoanConsultingInquiry",
  ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY_ERROR: "setReportBuyLoanConsultingInquiryError",
};
